// Floating "?" button anchored to the panel's top-right corner.
//
// Toggles the help menu overlay. Hidden when the panel has no help
// data (so simulators without annotations are visually identical to
// today's no-help build).

import { useHelp } from "./help-context";
import { helpHasContent } from "./help-data";

export function HelpButton() {
  const { panelKind, overlay, openOverlay, closeOverlay } = useHelp();
  if (!helpHasContent(panelKind)) return null;

  const open = overlay === "menu";

  return (
    <button
      type="button"
      aria-label={open ? "Close help" : "Open help"}
      aria-expanded={open}
      onClick={() => (open ? closeOverlay() : openOverlay("menu"))}
      style={{
        position: "absolute",
        top: 12,
        right: 12,
        zIndex: 30,
        width: 36,
        height: 36,
        borderRadius: "50%",
        border: "1px solid var(--rule, #d8d3c7)",
        background: "var(--white, #ffffff)",
        color: "var(--ink, #1b160a)",
        fontSize: 18,
        fontWeight: 700,
        cursor: "pointer",
        boxShadow: "0 2px 6px rgba(27, 22, 10, 0.12)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 0,
      }}
    >
      ?
    </button>
  );
}
